import React from 'react'
import { AppRouteURI, AppRoutingRoles } from 'router/RoleBasedAccess'
import App from '../../components/app/App'
import InvitesContainer from './InvitesContainer'

export default () => {
    const { isProtected, checkRoles } = {
        ...AppRoutingRoles[AppRouteURI.INVITES],
    }
    return (
        <App isProtected={isProtected} checkRoles={checkRoles}>
            <InvitesContainer />
        </App>
    )
}
